import * as tslib_1 from "tslib";
import * as React from 'react';
import * as ReactDOM from 'react-dom';
var ReactComment = /** @class */ (function (_super) {
    tslib_1.__extends(ReactComment, _super);
    function ReactComment() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ReactComment.prototype.componentDidMount = function () {
        var element = ReactDOM.findDOMNode(this);
        ReactDOM.unmountComponentAtNode(element);
        element.outerHTML = this.createComment();
    };
    ReactComment.prototype.createComment = function () {
        return "<!--" + this.props.text + "-->";
    };
    ReactComment.prototype.render = function () {
        return React.createElement("div", null);
    };
    return ReactComment;
}(React.Component));
export default ReactComment;
//# sourceMappingURL=ReactComment.js.map